export enum AccountType {
    company = 'company',
    individual = 'individual',
}


export enum AccountStatus {
    draft = 'draft',
    active = 'active',
    inactive = 'inactive',
    suspended = 'suspended',
}

export type BillingMode = 'postpaid' | 'prepaid' | 'free';

export interface IAccount {
    id: number;
    name: string;
    type: AccountType;
    firstName?: string | null;
    lastName?: string | null;
    legalId?: string | null;
    qontoClientId?: string | null;
    qontoSyncError?: boolean;
    qontoSyncErrorMessage?: string | null;
    vatNumber: string;
    address: string;
    zipCode: string;
    city: string;
    country: string;
    phone: string;
    email: string;
    status: AccountStatus;
    billingMode?: BillingMode;
    credit?: number;
    applyVat: boolean;
    customVatRate: number;
    //transactions: ITransaction[];
}